import React, { Component } from "react";
import Styles from "./styles/js/style";
import "./styles/styles.css";
import cookie from "react-cookies";
import FlexText from "../flexText";

let data_uri = "";

class GDPR extends Component {
  state = {
    agreed: "",
    data: {},
    laoding: true,
    error: false,
  };

  onButtonHover = e => {
    const t = document.getElementById(e.target.id);
    if (e.target.id === "iagree") {
      t.style.color = "#fff";
      t.style.backgroundColor = "#668600";
    } else if (e.target.id === "privacy") {
      t.style.color = "#f47d20";
      t.style.borderBottom = "1px dashed #f47d20";
    }
  };

  onButtonOut = e => {
    const t = document.getElementById(e.target.id);
    if (e.target.id === "iagree") {
      t.style.color = "#000";
      t.style.backgroundColor = "#a7d233";
    } else if (e.target.id === "privacy") {
      t.style.color = "#000";
      t.style.borderBottom = "1px dashed #444";
    }
  };

  onButtonPush = e => {
    const expires = new Date();
    expires.setDate(100);
    cookie.save("cookie-agreed", 2, {
      path: "/",
      expires,
      host: "https://*.uvm.edu"
    });
    const t = document.getElementById("gdprBlock");
    t.parentNode.removeChild(t);
  };

  componentDidMount() {
    this.setState({ agreed: cookie.load("cookie-agreed") });
    // set uri based on location (dev/staging/prod)
    switch (window.location.hostname) {
      case "react.drup2-dev.uvm.edu":
      case "localhost":
        data_uri = "https://uvmd9.drup2-dev.uvm.edu/jsonapi/block_content/basic/6356847f-e7b0-466c-b26e-c44f827eb09a";
        break;
      case "react.drup2-staging.uvm.edu":
        data_uri = "https://uvmd9.drup2-staging.uvm.edu/jsonapi/block_content/basic/6356847f-e7b0-466c-b26e-c44f827eb09a";
        break;
      default:
        data_uri = "https://uvmd9.uvm.edu/jsonapi/block_content/basic/6356847f-e7b0-466c-b26e-c44f827eb09a";
    }

    fetch(data_uri)
      .then(this.handleErrors) // handles response errors like 404
      .then(response => response.json())
      .then(data =>
        this.setState({
          data: data.data.attributes, loading: false,
        })
      )
      .catch(error => this.setState({ loading: false, error })); // Handles request errors like CORS
  }
    
  render() {
    const { data } = this.state;
    if (!this.state.agreed) {
      return (
        <div
          className="gdprBlock"
          id="gdprBlock"
          style={{
            ...Styles.gdprBlock
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <div
              className="textBlock"
              style={{
                ...Styles.textBlock
              }}
            >{typeof data.body !== "undefined"
            ? (<FlexText tag="span" styles={{
              fontSize: "17px",
              fontWeight: "700",
              lineHeight: "1.5em",
              }}>{data.body.value.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "").replace('<button class="agree-button eu-cookie-compliance-default-button" type="button">I Understand</button>', "")}</FlexText>)
            : null }
              <br />
              <button
                onMouseOver={this.onButtonHover}
                onMouseOut={this.onButtonOut}
                onClick={this.onButtonPush}
                className="iagree"
                id="iagree"
                style={{ ...Styles.button }}
              >
                I Understand
              </button>
            </div>
          </div>
        </div>
      );
    } else return null;
  }
}

export default GDPR;
